import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {

  @ViewChild('infoModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-sm', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  
  callback: Function;
  title: any = '';
  content: any = '';
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onInfo.subscribe(req => {
      this.title = '';
      this.content = '';
      this.title = req.title;
      this.content = req.content;
      this.callback = req.callback;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onInfoHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm(): void {
    this.isShow = false;
    this.callback({status: 'confirm'});
    if(this.modalRef){
      this.modalRef.hide();
    }
  }

}
